// extracted by css-extract-rspack-plugin
export default {"root":"sjDD0Q","loader":"oAnPD7"};